import { Component, Input } from '@angular/core';
import { Order } from '../../shared/entities/order/order';

@Component({
  selector: 'app-order-rent-details',
  templateUrl: './order-rent-details.component.html',
  styleUrls: ['./order-rent-details.component.scss']
})
export class OrderRentDetailsComponent {
  @Input() order: Order;
  public Order = Order;

}
